import { action, createRequestTypes } from './base';

export const workflowActionTypes = {
  GET_PURCHASE_WORKFLOWS: createRequestTypes('GET_PURCHASE_WORKFLOWS'),
  GET_VENDOR_WORKFLOWS: createRequestTypes('GET_VENDOR_WORKFLOWS'),
  GET_SALES_ESTIMATE_WORKFLOWS: createRequestTypes('GET_SALES_ESTIMATE_WORKFLOWS'),
  GET_SALES_ORDER_WORKFLOWS: createRequestTypes('GET_SALES_ORDER_WORKFLOWS'),
  GET_PACKING_SLIP_WORKFLOWS: createRequestTypes('GET_PACKING_SLIP_WORKFLOWS'),
  GET_INVOICE_WORKFLOWS: createRequestTypes('GET_INVOICE_WORKFLOWS'),
  GET_CREDIT_NOTE_WORKFLOWS: createRequestTypes('GET_CREDIT_NOTE_WORKFLOWS'),
  GET_DEBIT_NOTE_WORKFLOWS: createRequestTypes('GET_DEBIT_NOTE_WORKFLOWS'),
  GET_STOCK_ADJUSTMENT_WORKFLOWS: createRequestTypes('GET_STOCK_ADJUSTMENT_WORKFLOWS'),
  GET_STOCK_TRANSFER_WORKFLOWS: createRequestTypes('GET_STOCK_TRANSFER_WORKFLOWS'),
  GET_GOODS_RECEIVING_WORKFLOWS: createRequestTypes('GET_GOODS_RECEIVING_WORKFLOWS'),
  GET_PURCHASE_REQUEST_WORKFLOWS: createRequestTypes('GET_PURCHASE_REQUEST_WORKFLOWS'),
  CREATE_WORKFLOWS: createRequestTypes('CREATE_WORKFLOWS'),
  CREATE_WORKFLOW_V2: createRequestTypes('CREATE_WORKFLOW_V2'),
  GET_PURCHASE_WORKFLOW_SAMPLE: createRequestTypes('GET_PURCHASE_WORKFLOW_SAMPLE'),
  ADD_ADDITIONAL_WORKFLOW_APPROVALS: createRequestTypes('ADD_ADDITIONAL_WORKFLOW_APPROVALS'),
  GET_DELIVERY_CHALLAN_WORKFLOWS: createRequestTypes('GET_DELIVERY_CHALLAN_WORKFLOWS'),
  GET_BOM_WORKFLOWS: createRequestTypes('GET_BOM_WORKFLOWS'),
};

class WorkflowActions {
  // Purchase
  getPurchaseWorkflows = (callback) => action(workflowActionTypes.GET_PURCHASE_WORKFLOWS.REQUEST, {
    callback,
  });

  getPurchaseWorkflowsLoading = (getPurchaseWorkflowsLoading) => action(
    workflowActionTypes.GET_PURCHASE_WORKFLOWS.LOADING, {
    getPurchaseWorkflowsLoading,
  },
  );

  getPurchaseWorkflowsSuccess = (purchaseWorkflows) => action(
    workflowActionTypes.GET_PURCHASE_WORKFLOWS.SUCCESS, {
    purchaseWorkflows,
  },
  );

  // Vendor

  getVendorWorkflows = (callback) => action(workflowActionTypes.GET_VENDOR_WORKFLOWS.REQUEST, {
    callback,
  });

  getVendorWorkflowsLoading = (getVendorWorkflowsLoading) => action(
    workflowActionTypes.GET_VENDOR_WORKFLOWS.LOADING, {
    getVendorWorkflowsLoading,
  },
  );

  getVendorWorkflowsSuccess = (vendorWorkflows) => action(
    workflowActionTypes.GET_VENDOR_WORKFLOWS.SUCCESS, {
    vendorWorkflows,
  },
  );

  // Sales Estimate
  getSalesEstimateWorkflows = (callback) => action(workflowActionTypes.GET_SALES_ESTIMATE_WORKFLOWS.REQUEST, { callback });

  getSalesEstimateWorkflowsLoading = (getSalesEstimateWorkflowsLoading) => action(
    workflowActionTypes.GET_SALES_ESTIMATE_WORKFLOWS.LOADING, {
    getSalesEstimateWorkflowsLoading,
  },
  );

  getSalesEstimateWorkflowsSuccess = (salesEstimateWorkflows) => action(
    workflowActionTypes.GET_SALES_ESTIMATE_WORKFLOWS.SUCCESS, {
    salesEstimateWorkflows,
  },
  );

  // Sales Order
  getSalesOrderWorkflows = (callback) => action(workflowActionTypes.GET_SALES_ORDER_WORKFLOWS.REQUEST, { callback });

  getSalesOrderWorkflowsLoading = (getSalesOrderWorkflowsLoading) => action(
    workflowActionTypes.GET_SALES_ORDER_WORKFLOWS.LOADING, {
    getSalesOrderWorkflowsLoading,
  },
  );

  getSalesOrderWorkflowsSuccess = (salesOrderWorkflows) => action(
    workflowActionTypes.GET_SALES_ORDER_WORKFLOWS.SUCCESS, {
    salesOrderWorkflows,
  },
  );

  // Packing Slip
  getPackingSlipWorkflows = (callback) => action(workflowActionTypes.GET_PACKING_SLIP_WORKFLOWS.REQUEST, { callback });

  getPackingSlipWorkflowsLoading = (getPackingSlipWorkflowsLoading) => action(
    workflowActionTypes.GET_PACKING_SLIP_WORKFLOWS.LOADING, {
    getPackingSlipWorkflowsLoading,
  },
  );

  getPackingSlipWorkflowsSuccess = (packingSlipWorkflows) => action(
    workflowActionTypes.GET_PACKING_SLIP_WORKFLOWS.SUCCESS, {
    packingSlipWorkflows,
  },
  );

  // Invoice
  /**
   *
   * @return
   */
  getInvoiceWorkflows = (callback) => action(workflowActionTypes.GET_INVOICE_WORKFLOWS.REQUEST, { callback });

  /**
   *
   * @param {*} getInvoiceWorkflowsLoading
   * @return
   */
  getInvoiceWorkflowsLoading = (getInvoiceWorkflowsLoading) => action(
    workflowActionTypes.GET_INVOICE_WORKFLOWS.LOADING, {
    getInvoiceWorkflowsLoading,
  },
  );

  /**
   * @param invoiceWorkflows
   * @return
   */
  getInvoiceWorkflowsSuccess = (invoiceWorkflows) => action(
    workflowActionTypes.GET_INVOICE_WORKFLOWS.SUCCESS, {
    invoiceWorkflows,
  },
  );

  // Credit Note
  /**
   *
   * @return
   */
  getCreditNoteWorkflows = (callback) => action(workflowActionTypes.GET_CREDIT_NOTE_WORKFLOWS.REQUEST, { callback });

  /**
   *
   * @param {*} getCreditNoteWorkflowsLoading
   * @return
   */
  getCreditNoteWorkflowsLoading = (getCreditNoteWorkflowsLoading) => action(
    workflowActionTypes.GET_CREDIT_NOTE_WORKFLOWS.LOADING, {
    getCreditNoteWorkflowsLoading,
  },
  );

  /**
   * @param creditNoteWorkflows
   * @return
   */
  getCreditNoteWorkflowsSuccess = (creditNoteWorkflows) => action(
    workflowActionTypes.GET_CREDIT_NOTE_WORKFLOWS.SUCCESS, {
    creditNoteWorkflows,
  },
  );

  // Debit Note
  /**
   *
   * @return
   */
  getDebitNoteWorkflows = (callback) => action(workflowActionTypes.GET_DEBIT_NOTE_WORKFLOWS.REQUEST, { callback });

  /**
   *
   * @param {*} getDebitNoteWorkflowsLoading
   * @return
   */
  getDebitNoteWorkflowsLoading = (getDebitNoteWorkflowsLoading) => action(
    workflowActionTypes.GET_DEBIT_NOTE_WORKFLOWS.LOADING, {
    getDebitNoteWorkflowsLoading,
  },
  );

  /**
   * @param debitNoteWorkflows
   * @return
   */
  getDebitNoteWorkflowsSuccess = (debitNoteWorkflows) => action(
    workflowActionTypes.GET_DEBIT_NOTE_WORKFLOWS.SUCCESS, {
    debitNoteWorkflows,
  },
  );

  // Purchase Request
  /**
   *
   * @return
   */
  getPurchaseRequestWorkflows = (callback) => action(workflowActionTypes.GET_PURCHASE_REQUEST_WORKFLOWS.REQUEST, { callback });

  /**
   *
   * @param {*} getPurchaseRequestWorkflowsLoading
   * @return
   */
  getPurchaseRequestWorkflowsLoading = (getPurchaseRequestWorkflowsLoading) => action(
    workflowActionTypes.GET_PURCHASE_REQUEST_WORKFLOWS.LOADING, {
    getPurchaseRequestWorkflowsLoading,
  },
  );

  /**
   * @param purchaseRequestWorkflows
   * @return
   */
  getPurchaseRequestWorkflowsSuccess = (purchaseRequestWorkflows) => action(
    workflowActionTypes.GET_PURCHASE_REQUEST_WORKFLOWS.SUCCESS, {
    purchaseRequestWorkflows,
  },
  );

  // Stock Adjustment
  /**
   *
   * @return
   */
  getStockAdjustmentWorkflows = (callback) => action(workflowActionTypes.GET_STOCK_ADJUSTMENT_WORKFLOWS.REQUEST, { callback });

  /**
   *
   * @param {*} getStockAdjustmentWorkflowsLoading
   * @return
   */
  getStockAdjustmentWorkflowsLoading = (getStockAdjustmentWorkflowsLoading) => action(
    workflowActionTypes.GET_STOCK_ADJUSTMENT_WORKFLOWS.LOADING, {
    getStockAdjustmentWorkflowsLoading,
  },
  );

  /**
   * @param stockAdjustmentWorkflows
   * @return
   */
  getStockAdjustmentWorkflowsSuccess = (stockAdjustmentWorkflows) => action(
    workflowActionTypes.GET_STOCK_ADJUSTMENT_WORKFLOWS.SUCCESS, {
    stockAdjustmentWorkflows,
  },
  );

  // Stock Transfer
  /**
   *
   * @return
   */
  getStockTransferWorkflows = (callback) => action(workflowActionTypes.GET_STOCK_TRANSFER_WORKFLOWS.REQUEST, { callback });

  /**
   *
   * @param {*} getStockTransferWorkflowsLoading
   * @return
   */
  getStockTransferWorkflowsLoading = (getStockTransferWorkflowsLoading) => action(
    workflowActionTypes.GET_STOCK_TRANSFER_WORKFLOWS.LOADING, {
    getStockTransferWorkflowsLoading,
  },
  );

  /**
   * @param StockTransferWorkflowsSuccess
   * @return
   */
  getStockTransferWorkflowsSuccess = (StockTransferWorkflowsSuccess) => action(
    workflowActionTypes.GET_STOCK_TRANSFER_WORKFLOWS.SUCCESS, {
    StockTransferWorkflowsSuccess,
  },
  );

  // Goods Receiving
  /**
   *
   * @return
   */
  getGoodsReceivingWorkflows = (callback) => action(workflowActionTypes.GET_GOODS_RECEIVING_WORKFLOWS.REQUEST, { callback });

  /**
   *
   * @param {*} getGoodsReceivingWorkflowsLoading
   * @return
   */
  getGoodsReceivingWorkflowsLoading = (getGoodsReceivingWorkflowsLoading) => action(
    workflowActionTypes.GET_GOODS_RECEIVING_WORKFLOWS.LOADING, {
    getGoodsReceivingWorkflowsLoading,
  },
  );

  /**
   * @param StockTransferWorkflows
   * @return
   */
  getGoodsReceivingWorkflowsSuccess = (StockTransferWorkflows) => action(
    workflowActionTypes.GET_GOODS_RECEIVING_WORKFLOWS.SUCCESS, {
    StockTransferWorkflows,
  },
  );

  /**
   *
   * @param {*} payload
   * @param {*} callback
   * @return
   */
  createWorkflows = (payload, callback) => action(workflowActionTypes.CREATE_WORKFLOWS.REQUEST, {
    payload,
    callback,
  });

  /**
   *
   * @param {*} createWorkflowsLoading
   * @return
   */
  createWorkflowsLoading = (createWorkflowsLoading) => action(workflowActionTypes.CREATE_WORKFLOWS.LOADING, {
    createWorkflowsLoading,
  });

  /**
   * @return
   * @param tenantId
   * @param sampleType
   */
  getPurchaseWorkflowSample = (tenantId, sampleType) => action(workflowActionTypes.GET_PURCHASE_WORKFLOW_SAMPLE.REQUEST, { tenantId, sampleType });

  /**
   * @param getPurchaseWorkflowSampleLoading
   * @param {*} getPurchaseWorkflowsLoading
   * @return
   */
  getPurchaseWorkflowSampleLoading = (getPurchaseWorkflowSampleLoading) => action(
    workflowActionTypes.GET_PURCHASE_WORKFLOW_SAMPLE.LOADING, {
    getPurchaseWorkflowSampleLoading,
  },
  );

  /**
   * @param samplePoWorkflow
   * @param purchaseWorkflows
   * @return
   */
  getPurchaseWorkflowsSampleSuccess = (samplePoWorkflow) => action(
    workflowActionTypes.GET_PURCHASE_WORKFLOW_SAMPLE.SUCCESS, {
    samplePoWorkflow,
  },
  );

  /**
   *
   * @param payload
   * @param callback
   * @returns {{type: *}}
   */
  createWorkflowV2 = (payload, callback) => action(workflowActionTypes.CREATE_WORKFLOW_V2.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @param createWorkflowV2Loading
   * @returns {{type: *}}
   */
  createWorkflowV2Loading = (createWorkflowV2Loading) => action(workflowActionTypes.CREATE_WORKFLOW_V2.LOADING, {
    createWorkflowV2Loading,
  })

  // Delivery Challan
  getDeliveryChallanWorkflows = (callback) => action(workflowActionTypes.GET_DELIVERY_CHALLAN_WORKFLOWS.REQUEST, { callback });

  getDeliveryChallanWorkflowsLoading = (getDeliveryChallanWorkflowsLoading) => action(
    workflowActionTypes.GET_DELIVERY_CHALLAN_WORKFLOWS.LOADING, {
    getDeliveryChallanWorkflowsLoading,
  },
  );

  getDeliveryChallanWorkflowsSuccess = (deliveryChallanWorkflows) => action(workflowActionTypes.GET_DELIVERY_CHALLAN_WORKFLOWS.SUCCESS, { deliveryChallanWorkflows });

  // add additional workflow approvals
  addAdditionalWorkflowApprovals = (payload, callback) => action(workflowActionTypes.ADD_ADDITIONAL_WORKFLOW_APPROVALS.REQUEST, {
    payload, callback,
  })

  addAdditionalWorkflowApprovalsLoading = (addAdditionalWorkflowApprovalsLoading) => action(workflowActionTypes.ADD_ADDITIONAL_WORKFLOW_APPROVALS.LOADING, {
    addAdditionalWorkflowApprovalsLoading,
  })

  getBOMWorkflows = (callback) => action(workflowActionTypes.GET_BOM_WORKFLOWS.REQUEST, { callback });

  getBOMWorkflowsLoading = (getBOMWorkflowsLoading) => action(workflowActionTypes.GET_BOM_WORKFLOWS.LOADING, {
    getBOMWorkflowsLoading,
  });

  getBOMWorkflowsSuccess = (BOMWorkflows) => action(workflowActionTypes.GET_BOM_WORKFLOWS.SUCCESS, { BOMWorkflows });

}

export default new WorkflowActions();
